function _typeof(o) {
  "@babel/helpers - typeof";
  return (
    (_typeof =
      "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (o) {
          return typeof o;
        }
        : function (o) {
          return o &&
            "function" == typeof Symbol &&
            o.constructor === Symbol &&
            o !== Symbol.prototype
            ? "symbol"
            : typeof o;
        }),
    _typeof(o)
  );
}
define("ProductModifications.EntryPoint", [
  "Utils",
  "PDPModifications.View",
  "ItemRelations.Related.View",
  "SDB.SDBLocations.Model",
  "Facets.Browse.View",
  "SDB.SDBLocations.Modal.View",
  "Backbone",
  "GlobalViews.Breadcrumb.View",
  // 'SDB.SelectWheelsOrTires.SS2Model',
  // 'SDB.Modal.Content.View',
  // 'SDB.SelectYourVehicle.View',
  "StockItemActions.View",
  "Facets.FacetsDisplay.View",
  "Facets.Translator",
  "ProductDetails.ImageGallery.View",
  "Utilities.ResizeImage",
  "PLPBreadCrumbs.View",
  "ProductViews.Price.View",
  "ProductDetails.Base.View",
  "Item.Model",
  "Facets.FacetedNavigationItem.View",
  "MobileFacetButtons.View",
  "ProductDetails.Information.View",
  "Header.MiniCartItemCell.View",
  "Cart.Detailed.View",
  "ItemsSearcher.Item.View",
  "ItemsSearcher.View",
], function (
  Utils,
  PDPModificationsView,
  ItemRelationsRelatedView,
  SDBLocationsModel,
  FacetsBrowseView,
  SDBLocationsModalView,
  Backbone,
  GlobalViewsBreadcrumbView,
  // SDBSelectWheelsOrTiresSS2Model,
  // SDBModalContentView,
  // SDBSelectYourVehicleView,
  StockItemActions,
  FacetsDisplay,
  FacetsTranslator,
  PDPImageGallery,
  resizeImage,
  PLPBreadCrumbs,
  ProductViewsPriceView,
  ProductDetailsBaseView,
  ItemModel,
  FacetsFacetedNavigationItemView,
  MobileFacetButtonsView,
  ProductDetailsInformationView,
  HeaderMiniCartItemCellView,
  CartDetailedView,
  ItemsSearcherItemView,
  ItemsSearcherView
) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      try {
        var PDP = container.getComponent("PDP");
        var PLP = container.getComponent("PLP");
        var CART = container.getComponent("Cart");
        var LAYOUT = container.getComponent("Layout");
        var env = container.getComponent("Environment");
        var selectedVehicle;

        var locationsModel = SDBLocationsModel.getInstance();
        if (env.getConfig("SDBFindPerfectFit.UseVehicleConfig")) {
          var SDBSelectWheelsOrTiresSS2Model = require("SDB.SelectWheelsOrTires.SS2Model");
          var SDBSelectYourVehicleView = require("SDB.SelectYourVehicle.View");
          var SDBModalContentView = require("SDB.Modal.Content.View");
        }
        var wheelsOrTiresModel = SDBSelectWheelsOrTiresSS2Model
          ? SDBSelectWheelsOrTiresSS2Model.getInstance()
          : null;

        FacetsTranslator.prototype.getApiParams = function () {
          try {
            var params = {};
            _.each(this.facets, function (facet) {
              switch (facet.config.behavior) {
                case "range":
                  var value =
                    _typeof(facet.value) === "object"
                      ? facet.value
                      : { from: 0, to: facet.value };
                  params[facet.id + ".from"] = value.from;
                  params[facet.id + ".to"] = value.to;
                  break;
                case "multi":
                  params[facet.id] = facet.value.sort().join(","); // this coma is part of the api call so it should not be removed
                  break;
                default:
                  params[facet.id] = facet.value;
              }
            });
            params.sort = this.options.order;
            params.limit = this.options.show;
            params.offset =
              this.options.show * this.options.page - this.options.show;
            params.q = this.options.keywords;
            if (this.isCategoryPage) {
              params.commercecategoryurl = this.categoryUrl;
              params.sort = params.sort.replace(
                "relevance",
                "commercecategory"
              );
            }
            // CUSTOM SORT
            var defaultValue = env.getConfig(
              "SDBPProductModifications.DefaultValue"
            );
            var shoppingExperience =
              locationsModel.getShoppingExperience() || "online";
            var currentLocation =
              (shoppingExperience !== "online" &&
                locationsModel.getSelectedLocation()) ||
              locationsModel.get("onlineLocation");
            var mapper = locationsModel.getFieldMapper(env);
            var mapValue = mapper[currentLocation.name.toUpperCase()];
            if (params.sort && mapValue) {
              var newSort = mapValue.internal + ":desc";
              if (params.sort.indexOf(defaultValue) === -1)
                newSort += "," + defaultValue + ":desc";
              newSort += ",custitem_external_inventory_count:desc";
              _.each(mapper, function (element) {
                if (mapValue.internal === element.internal) return;
                newSort += "," + element.internal + ":desc";
              });
              if (
                params.sort.indexOf("relevance") !== -1 ||
                params.sort.indexOf("commercecategory") !== -1
              ) {
                newSort += "," + params.sort;
                params.sort = newSort.trim();
              } else {
                newSort = params.sort + "," + newSort;
                params.sort = newSort.trim();
              }
            }
            // console.log('SORT PARAMS: ', params);
            return params;
          } catch (error) {
            console.error(
              "ERROR: FacetsTranslator.prototype.getApiParams",
              error
            );
          }
        };

        if (PLP) {
          if (LAYOUT) {
            LAYOUT.addChildView("Mobile.Facet.Action.Buttons", function () {
              return new MobileFacetButtonsView({ container: container });
            });
          }

          var showLocationsModal = function showLocationsModal() {
            try {
              var modalView = new SDBLocationsModalView({
                container: container,
                view: SDBLocationsModalView,
                pageHeader: "Select a location",
                locations: locationsModel.getLocations(),
              });
              LAYOUT.showContent(modalView, { showInModal: true });
            } catch (error) {
              console.log(error);
            }
          };

          var showSelectVehicleModal = function showSelectVehicleModal() {
            try {
              var modalView = new SDBModalContentView({
                container: container,
                view: SDBModalContentView,
                contentView: SDBSelectYourVehicleView,
                pageHeader: "Select a vehicle",
              });
              LAYOUT.showContent(modalView, { showInModal: true });
            } catch (error) {
              console.log("showSelectVehicleModal:" + error);
            }
          };
          // TODO: need to define what extra options are going to be added in the plp as by brand or model there are a lot of items
          // , and we are not sure what information we should show to the customer in the plp
          PLP.addToViewContextDefinition(
            "Facets.ItemCell.View",
            "itemChangesPLP",
            "string",
            function itemChangesPLP(context) {
              var model = _.find(PLP.getItemsInfo(), function (item) {
                return item.internalid == context.itemId;
              });

              if (model) {
                var itemType = model.class;
                var modelName = model.custitemrs_model;
                var words = itemType ? itemType.toLowerCase().split(" ") : null;
                var isTire = _.contains(words, "tire");
                var isWheel = _.contains(words, "wheel");
                isTire
                  ? (itemType = "Tires")
                  : isWheel
                    ? (itemType = "Wheels")
                    : (itemType = null);
                return {
                  brand: model.custitemrs_brand,
                  itemType: itemType,
                  modelName: modelName,
                };
              }
            }
          );

          if (env.getConfig("SDBFindPerfectFit.UseVehicleConfig")) {
            PLP.on("afterShowContent", function () {
              var button = document.querySelector(
                '[data-action="change-vehicle"]'
              );

              if (button) {
                button.addEventListener("click", function () {
                  showSelectVehicleModal();
                });
              }
            });
          }

          FacetsBrowseView.prototype.initialize = _.wrap(
            FacetsBrowseView.prototype.initialize,
            function (fn) {
              fn.apply(this, _.toArray(arguments).slice(1));
              var self = this;

              this.updateApiParams = function updateApiParams() {
                var URL = this.translator.getUrl();
                this.model.set(
                  { data: this.translator.getApiParams() },
                  { silent: true }
                );
                Backbone.history.navigate(URL, { trigger: true });
              };

              this.listenTo(locationsModel, {
                "change:shoppingExperience": function changeShoppingExperience(
                  model,
                  experience
                ) {
                  if (experience === "online") self.updateApiParams();
                },
                "change:location": self.updateApiParams,
              });
            }
          );

          FacetsBrowseView.prototype.getContext = _.wrap(
            FacetsBrowseView.prototype.getContext,
            function (fn) {
              var context = fn.apply(this, _.toArray(arguments).slice(1));
              var modifications = env.getConfig(
                "SDBPProductModifications.plpConfig"
              )[0];
              var pagination = PLP.getPagination();

              if (pagination) {
                var paginationMessage = {
                  from: pagination.pageSize * (pagination.currentPage - 1) + 1,
                  to:
                    pagination.pageSize * pagination.currentPage <=
                      pagination.itemCount
                      ? pagination.pageSize * pagination.currentPage
                      : pagination.itemCount,
                  total: pagination.itemCount,
                };
              }
              var title = modifications.title;
              var titleWithoutLastWord = title.substring(
                0,
                title.lastIndexOf(" ")
              );
              var titleLastWord = title.substring(title.lastIndexOf(" ") + 1);
              // if (wheelsOrTiresModel) {
              //     var cookies = wheelsOrTiresModel.getCookieOptions();

              //     var validateOfCookies = cookies.some(function (cookie) {
              //         return cookie.indexOf('isSelectedTires') !== 1 || cookie.indexOf('vehicle=') !== -1
              //     });

              //     if (validateOfCookies && cookies.length > 0) {
              //         var vehicleData = cookies.find(function (cookie) {
              //             return cookie.indexOf('vehicle=') !== -1
              //         }).split(',');
              //         if(!vehicleData) return;

              //         var vehicle = {
              //             year: vehicleData[0].split(':')[1].replace(/["\\]/g, '').toUpperCase(),
              //             make: vehicleData[1].split(':')[1].replace(/["\\]/g, '').toUpperCase(),
              //             model: vehicleData[2].split(':')[1].replace(/["\\}]/g, '').toUpperCase()
              //         }
              //         modifications.vehicle = vehicle;
              //     }

              //     var tireFlagData = wheelsOrTiresModel.getParsedCookieOptions(['isSelectedTires']);

              //     if (tireFlagData && Object.hasOwnProperty.call(tireFlagData, 'isSelectedTires')) {
              //         modifications.isTire = !!(tireFlagData.isSelectedTires === 'true');
              //     }
              // }

              modifications.titleLastWord = titleLastWord;
              modifications.titleWithoutLastWord = titleWithoutLastWord;

              if (
                locationsModel.isLocationSelected() &&
                locationsModel.getShoppingExperience() !== "online"
              ) {
                modifications.location = false;
              } else {
                modifications.location = true;
              }

              if (!PLP) context.modifications = modifications;
              context.paginationMessage = paginationMessage;
              return context;
            }
          );

          FacetsDisplay.prototype.getContext = _.wrap(
            FacetsDisplay.prototype.getContext,
            function (fn) {
              var context = fn.apply(this, _.toArray(arguments).slice(1));

              var facets = this.options.facets;
              var translator = this.options.translator;

              _.each(facets, function (facet) {
                facet.value = _.isArray(facet.value)
                  ? facet.value
                  : [facet.value];
              });

              var facet_values = [];

              _.each(facets, function (facet) {
                var parser = facet.config.parser;

                _.each(facet.value, function (value) {
                  var from = _.isObject(value) ? value.from : "";
                  var to = _.isObject(value) ? value.to : "";
                  var value_data = {
                    facetValueIsObject: _.isObject(value),
                    from: from && parser ? parser(from) : from,
                    to: to && parser ? parser(to) : to,
                    valueLabel: translator.getLabelForValue(facet.id, value),
                    facetValueUrl: translator
                      .cloneForFacetId(facet.id, value)
                      .getUrl(),
                    facetValue: facet.value,
                    facetName: facet.config.name,
                  };

                  facet_values.push(value_data);
                });
              });
              context.values = facet_values;
              return context;
            }
          );

          LAYOUT.addToViewEventsDefinition(
            "Facets.Browse.View",
            'click [data-action="location"]',
            function (event) {
              if (!locationsModel.isLocationSelected()) {
                showLocationsModal();
              } else {
                Backbone.history.navigate("/finance", { trigger: true });
              }
            }
          );

          PLP.addChildView("PLP.Breadcrumb", function () {
            var layout = container.getLayout();
            var browseView = layout.currentView;
            var breadcrumbs = _.union(
              layout.getBreadcrumbPrefix(),
              browseView.getBreadcrumbPages()
            );
            return new PLPBreadCrumbs({
              container: container,
              breadcrumbs: breadcrumbs,
              showBreadcrumbMicrodata:
                env.getConfig("structureddatamarkup.type") !== "JSON-LD",
            });
          });
          GlobalViewsBreadcrumbView.prototype.getContext = _.wrap(
            GlobalViewsBreadcrumbView.prototype.getContext,
            function (fn) {
              var context = fn.apply(this, _.toArray(arguments).slice(1));
              context.showBreadcrumbMicrodata =
                env.getConfig("structureddatamarkup.type") !== "JSON-LD";
              var parentView = this.parentView._currentView;
              if (!parentView) return context;
              var viewId = parentView && parentView.el.id;
              if (viewId && viewId.indexOf("facet-browse") !== -1) {
                context.isPLP = true;
              }
              return context;
            }
          );

          var filterFacet = function filterFacet(value, filter) {
            if (!value || !filter) return false;
            value = value.toUpperCase();
            filter = filter.toUpperCase();

            var fullMatch = value.indexOf(filter) != -1;
            if (fullMatch) return true;

            var filterWords = _.uniq(filter.match(/[A-Za-z0-9]+/g));
            var wordsMatch = false;
            if (filterWords && filterWords.length) {
              wordsMatch = true;
              for (var i = 0; i < filterWords.length; i++) {
                if (value.indexOf(filterWords[i]) == -1) {
                  wordsMatch = false;
                  return;
                }
              }
            }
            return wordsMatch;
          };
          FacetsFacetedNavigationItemView.prototype.getContext = _.wrap(
            FacetsFacetedNavigationItemView.prototype.getContext,
            function (fn) {
              //featured items facet should be hidden
              if (this.model.get("id") == "custitem_sdb_feature_item") return;
              //filter does not apply to range facets
              if (this.facet_config.behavior == "range")
                return fn.apply(this, _.toArray(arguments).slice(1));
              var self = this;
              var filterValue = sessionStorage.getItem(self.facetId);
              var hideSearch = false;
              var noResults = false;
              var maxLength = Number(this.facet_config.max);

              //get the relevant values from the plp component
              var plpFilter = _.find(PLP.getAllFilters(), function (value) {
                return value.url == self.model.get("url");
              });
              var valuesPLP =
                (plpFilter && plpFilter.values) ||
                self.options.model.get("values") ||
                [];
              //hide search bar if there are only a few options
              if (valuesPLP.length <= maxLength) hideSearch = true;

              //apply filter
              if (filterValue) {
                self.options.model.attributes.values = _.filter(
                  valuesPLP,
                  function (value) {
                    return filterFacet(value.label, filterValue);
                  },
                  {}
                );
                sessionStorage.removeItem(self.facetId);
              }
              //prevent the facet from disappearing when there are no results after filtering
              if (
                !self.options.model.get("values").length &&
                valuesPLP.length
              ) {
                self.options.model.attributes.values = valuesPLP;
                noResults = true;
              }
              //reset values if the search bar is empty
              if (filterValue == "")
                self.options.model.attributes.values = valuesPLP;

              //put selected values at the top of the list
              var selectedValues = this.options.translator.getFacetValue(
                this.facetId
              );
              if (!selectedValues) selectedValues = [];
              if (!_.isArray(selectedValues)) selectedValues = [selectedValues];
              var topValues = [];
              var bottomValues = [];
              _.each(self.options.model.attributes.values, function (value) {
                if (value.url !== "" && _.contains(selectedValues, value.url))
                  topValues.push(value);
                else bottomValues.push(value);
              });
              self.options.model.attributes.values =
                topValues.concat(bottomValues);
              if (self.notFirstExec) {
                var collapsableElement = self.el.querySelector(
                  ".facets-faceted-navigation-item-facet-group-wrapper"
                );
                self.facet_config.collapsed = !_.contains(
                  collapsableElement.classList,
                  "in"
                );
              } else if (selectedValues.length) {
                self.facet_config.collapsed = false;
              }

              var ctx = fn.apply(this, _.toArray(arguments).slice(1));
              //add custom template variables to the context
              ctx.filterValue = filterValue;
              ctx.hideSearch = hideSearch;
              ctx.noResults = noResults;
              self.notFirstExec = true;
              return ctx;
            }
          );
          var keyAction = function keyAction(e) {
            sessionStorage.setItem(this.facetId, e.target.value);
            this.render();
          };
          var focusOnSearch = function focusOnSearch(e) {
            var input = this.el.querySelector(
              'input[value="' + e.target.value + '"]'
            );
            var length = input.value.length;
            input.focus();
            input.setSelectionRange(length, length);
          };
          //function to only trigger the filter after the user stops typing
          var keyupDebounce = function keyupDebounce(func, delay, focus) {
            return function () {
              var args = Array.prototype.slice.call(arguments);
              var contextualSelf = this;
              if (!this.searchChanged) {
                var isNotArrow = !(
                  args[0].key.toLowerCase().indexOf("arrow") != -1
                );
                var isNotShift = !(
                  args[0].key.toLowerCase().indexOf("shift") != -1
                );
                var isNotControl = !(
                  args[0].key.toLowerCase().indexOf("control") != -1
                );
                this.searchChanged = isNotArrow && isNotShift && isNotControl;
              }
              clearTimeout(this.timer);
              this.timer = setTimeout(function () {
                if (!contextualSelf.searchChanged) return;
                contextualSelf.searchChanged = false;
                func.apply(contextualSelf, args);
                setTimeout(function () {
                  focus.apply(contextualSelf, args);
                }, 100);
              }, delay);
            };
          }
          FacetsFacetedNavigationItemView.prototype.keyAction = keyupDebounce(
            keyAction,
            600,
            focusOnSearch
          );
          FacetsFacetedNavigationItemView.prototype.events[
            "keyup .search-facet-values-input"
          ] = "keyAction";
        }
        if (PDP) {
          ProductDetailsInformationView.prototype.getContext = _.wrap(
            ProductDetailsInformationView.prototype.getContext,
            function (fn) {
              var ctx = fn.apply(
                this,
                Array.prototype.slice.call(arguments, 1)
              );
              _.each(ctx.details, function (element) {
                if (element.content.indexOf("|") !== -1)
                  element.content =
                    "&#149 " + element.content.replace(/\|/g, "<br>&#149 ");
              });
              return ctx;
            }
          );

          PDP.addToViewContextDefinition(
            "ProductDetails.Information.View", // view_id
            "strDeviceType", // property_name
            "string", // type
            function (context) {
              // callback
              return Utils.getDeviceType();
            }
          );
          PDP.addToViewContextDefinition(
            "ProductDetails.Full.View", // view_id
            "strDeviceType", // property_name
            "string", // type
            function (context) {
              // callback
              return Utils.getDeviceType();
            }
          );

          PDP.addToViewContextDefinition(
            "ProductDetails.Full.View",
            "wheelsOrTires",
            "object",
            function (context) {
              var itemInfo = PDP.getItemInfo();
              if (!itemInfo) {
                return {};
              }
              var item = itemInfo.item;
              var wheelDiameter = item.custitemrs_wheel_diameter_min;
              var tireSize = item.custitemrs_tire_inside_diameter;

              if (wheelDiameter) {
                return {
                  wheelDiameter: wheelDiameter,
                };
              } else if (tireSize) {
                return {
                  tireSize: tireSize,
                };
              } else {
                return {};
              }
            }
          );

          PDP.addToViewEventsDefinition(
            "ProductDetails.Full.View",
            'click [data-action="add-to-cart-and-shop"]',
            function (e) {
              e.preventDefault();

              var itemInfo = PDP.getItemInfo();
              var item = itemInfo.item;
              var itemType = itemInfo.item.class;
              var quantity = itemInfo.quantity;
              var id = item.internalid;
              var wheelDiameter = item.custitemrs_wheel_diameter_min;
              var tireSize = item.custitemrs_tire_inside_diameter;
              // var cookies = wheelsOrTiresModel ? wheelsOrTiresModel.getCookieOptions() : null;

              // if (cookies && cookies.length > 1) {
              //     var vehicleData = cookies.find(function (cookie) {
              //         return cookie.indexOf('vehicle=') !== -1
              //     })
              //     if (vehicleData) vehicleData = vehicleData.split('=')[1];
              //     var vehicleConfig = cookies.find(function (cookie) {
              //         return cookie.indexOf('vehicleConfig=') !== -1
              //     })
              //     if (vehicleConfig) vehicleConfig = vehicleConfig.split('=')[1];
              //     var selectedSize = cookies.find(function (cookie) {
              //         return cookie.indexOf('selectedSize=') !== -1
              //     })
              //     if (selectedSize) selectedSize = selectedSize.split('=')[1];

              //     if (vehicleData) selectedVehicle = JSON.parse(vehicleData);
              // }

              CART.addLine({
                line: {
                  quantity: quantity,
                  item: {
                    internalid: id,
                  },
                },
              }).then(function () {
                // if (selectedVehicle !== undefined) {
                //     document.cookie = 'isSelectedTires=false; path=/; expires=Fri, 31 Dec 1999 23:59:59 GMT';
                //     if (wheelsOrTiresModel) {
                //         wheelsOrTiresModel.setCookieOptions({
                //             isSelectedTires: itemType.indexOf('WHEELS') !== -1 ? true : false,
                //             vehicleConfig: vehicleConfig,
                //             vehicle: JSON.stringify(selectedVehicle),
                //             selectedSize: selectedSize
                //         });
                //     }
                //     document.cookie = 'setFilters=' + true + '; path=/;';

                //     Backbone.history.navigate('/search', { trigger: true });

                // } else {
                //     itemType.indexOf('WHEELS') !== -1 ? Backbone.history.navigate('/search?InsideDiameter=' + wheelDiameter, { trigger: true }) : Backbone.history.navigate('/search' + '?WheelDiameter=' + tireSize, { trigger: true });
                // }
                var wheelFacetUrlConfig = env.getConfig(
                  "SDBFindPerfectFit.Wheels"
                );
                var wheelDiameterFacet = _.find(
                  wheelFacetUrlConfig,
                  function (value) {
                    return value.facet == "custitemrs_wheel_diameter_min";
                  }
                ).UrlComponent;
                var tireFacetUrlConfig = env.getConfig(
                  "SDBFindPerfectFit.Tires"
                );
                var tireDiameterFacet = _.find(
                  tireFacetUrlConfig,
                  function (value) {
                    return value.facet == "custitemrs_tire_inside_diameter";
                  }
                ).UrlComponent;
                itemType.indexOf("WHEELS") !== -1
                  ? Backbone.history.navigate(
                    "/search?" + tireDiameterFacet + "=" + wheelDiameter,
                    { trigger: true }
                  )
                  : Backbone.history.navigate(
                    "/search" + "?" + wheelDiameterFacet + "=" + tireSize,
                    { trigger: true }
                  );
              });
            }
          );

          PDP.addToViewContextDefinition(
            "ProductDetails.Full.View", // view_id
            "pdpExtraInformation", // property_name
            "string", // type
            function (context) {
              // callback
              var model = context.model.item;
              var itemType = model.class;
              var modelName = model.custitemrs_model;
              var words = itemType ? itemType.toLowerCase().split(" ") : null;
              var isTire = _.contains(words, "tire");
              var isWheel = _.contains(words, "wheel");
              var brand = model.custitemrs_brand;

              isTire
                ? (itemType = "Tires")
                : isWheel
                  ? (itemType = "Wheels")
                  : (itemType = null);
              return {
                brand:
                  isTire && brand && brand.indexOf("Tires")
                    ? brand.replace("Tires", "")
                    : isWheel && brand && brand.indexOf("Wheels")
                      ? brand.replace("Wheels", "")
                      : null,
                itemType: itemType,
                modelName: modelName,
                alteredName: brand && modelName ? true : false,
              };
            }
          );

          PDP.addChildView("Product.Details.Table", function () {
            var itemInfo = PDP.getItemInfo();

            return new PDPModificationsView({
              container: container,
              itemInfo: itemInfo,
            });
          });

          _.extend(PDPImageGallery.prototype, {
            initZoom: _.wrap(PDPImageGallery.prototype.initZoom, function (fn) {
              var aux = SC.ENVIRONMENT.isTouchEnabled;
              SC.ENVIRONMENT.isTouchEnabled = false;
              fn.apply(this, _.toArray(arguments).slice(1));
              SC.ENVIRONMENT.isTouchEnabled = aux;
            }),
            buildSliderPager: function buildSliderPager(slide_index) {
              var image = this.images[slide_index];
              if (image) {
                return (
                  '<img src="' +
                  resizeImage(image.url, "item_slides") +
                  '" alt="' +
                  image.altimagetext +
                  '">'
                );
              }
            },

            events: {
              "click .custom-pager-indicator button": "activateCustomPager",
              "click .bx-custom-pager": "updateCustomPager",
            },

            updateCustomPager: function updateCustomPager(e) {
              var self = this;
              var element = $(e.target).get(0);
              var index = element
                .querySelector("a")
                .getAttribute("data-slide-index");
              var target = $(".custom-pager-indicator button").eq(index);
              self.activateCustomPager(e, index, target);
            },
            activateCustomPager: function activateCustomPager(
              e,
              indexToActivate,
              targetClass
            ) {
              var self = this;
              var element = targetClass ? targetClass : $(e.currentTarget);
              element.siblings().removeClass("active");
              var index = element.index();
              if (!element.hasClass("active")) {
                element.addClass("active");
              }
              if (indexToActivate) {
                index = indexToActivate;
              }
              self.$slider.goToSlide(index);
            },
          });
        }
        ProductViewsPriceView.prototype.getContext = _.wrap(
          ProductViewsPriceView.prototype.getContext,
          function (fn) {
            var context = fn.apply(this, _.toArray(arguments).slice(1));
            var itemInfo = "";
            var hidePrice = false;
            if (!Backbone.history.fragment.includes("cart")) {
              itemInfo = PDP.getItemInfo();
              hidePrice = itemInfo
                ? itemInfo.item.custitem_sdb_item_hide_price
                : context.model && context.model.attributes.item
                  ? context.model.attributes.item.attributes
                    .custitem_sdb_item_hide_price
                  : false;
            } else {
              itemInfo = context.model;
              hidePrice = context.model.custitem_sdb_item_hide_price
                ? context.model.custitem_sdb_item_hide_price
                : context.model.attributes.custitem_sdb_item_hide_price;
            }

            if (hidePrice) {
              context.priceFormatted = "Contact for pricing";
              context.price = "Contact for pricing";
            }
            return context;
          }
        );

        _.extend(ItemRelationsRelatedView.prototype, {
          initialize: _.wrap(
            ItemRelationsRelatedView.prototype.initialize,
            function (fn) {
              fn.apply(this, _.toArray(arguments).slice(1));
            }
          ),
          carouselInitialize: function carouselInitialize() {
            var config = this.options.application.getConfig();
            var siteSettings = config.siteSettings;
            var imageSizeMapping = config.imageSizeMapping;
            var carousel = this.$el.find('[data-type="carousel-items"]');

            if (carousel.length > 0) {
              if (
                Utils.isPhoneDevice() === false &&
                (siteSettings.imagesizes || false)
              ) {
                var img_min_height = _.where(siteSettings.imagesizes || [], {
                  name: imageSizeMapping.thumbnail || "",
                })[0].maxheight;

                carousel
                  .find(".item-relations-related-item-thumbnail")
                  .css("minHeight", img_min_height);
              }
              var options = config.get("bxSliderDefaults");
              options.slideMargin = 20;
              options.pager = true;
              options.controls = false;

              Utils.initBxSlider(carousel, options, {});
            }
          },
        });

        var sortUrls = function sortUrls(urls) {
          try {
            var sortedImages = {};
            var imagesKeys = Object.keys(urls);
            var images = imagesKeys.map(function (key) {
              return { key: key, image: urls[key] };
            });
            var sortedUrls = _.sortBy(images, function (item) {
              var match;
              if (item.image.url) match = item.image.url.match(/(\d+)\.\w+$/);
              return match ? parseInt(match[1], 10) : 0;
            });
            for (var i = 0; i < sortedUrls.length; i++) {
              sortedImages[sortedUrls[i].key] = sortedUrls[i].image;
            }
            return sortedImages;
          } catch (error) {
            console.log(error);
            return urls;
          }
        }

        var sortImages = function sortImages(item_model) {
          if (item_model) {
            var imagesObject = item_model.get("itemimages_detail");
            if (imagesObject) {
              var imagesKeys = Object.keys(imagesObject);
              if (!imagesKeys.length) return;
              while (
                imagesObject &&
                !_.has(imagesObject[imagesKeys[0]], "url")
              ) {
                imagesObject = imagesObject[imagesKeys[0]];
                imagesKeys = Object.keys(imagesObject);
              }
              if (!imagesObject) return;
              var sortedUrls = sortUrls(imagesObject);
              if (sortedUrls) {
                imagesObject = sortedUrls;
              }
            }
          }
          if (imagesObject) return imagesObject;
          return null;
        }

        ProductDetailsBaseView.prototype.getContext = _.wrap(
          ProductDetailsBaseView.prototype.getContext,
          function (fn) {
            var context = fn.apply(this, _.toArray(arguments).slice(1));
            if (!this.model || !this.model.attributes) return context;
            var item_model = this.model.get("item");
            var imagesObject = sortImages(item_model);
            if (imagesObject)
              context.model.attributes.item.attributes.itemimages_detail =
                imagesObject;
            return context;
          }
        );

        ItemModel.prototype.getThumbnail = _.wrap(
          ItemModel.prototype.getThumbnail,
          function (fn) {
            if (!this.attributes) fn.apply(this, _.toArray(arguments).slice(1));
            var item_model = this;
            var imagesObject = sortImages(item_model);
            if (imagesObject) this.attributes.itemimages_detail = imagesObject;
            return fn.apply(this, _.toArray(arguments).slice(1));
          }
        );

        CartDetailedView.prototype.getContext = _.wrap(
          CartDetailedView.prototype.getContext,
          function (fn) {
            if (!this.model || !this.model.attributes)
              return fn.apply(this, _.toArray(arguments).slice(1));
            _.each(this.model.get("lines").models, function (model) {
              var item_model = model.get("item");
              var imagesObject = sortImages(item_model);
              if (imagesObject)
                item_model.attributes.itemimages_detail = imagesObject;
            });
            return fn.apply(this, _.toArray(arguments).slice(1));
          }
        );
        ItemsSearcherItemView.prototype.getContext = _.wrap(
          ItemsSearcherItemView.prototype.getContext,
          function (fn) {
            var item_model = this.model;
            var imagesObject = sortImages(item_model);
            if (imagesObject)
              item_model.attributes.itemimages_detail = imagesObject;
            return fn.apply(this, _.toArray(arguments).slice(1));
          }
        );
        ItemsSearcherView.prototype.getItemIds = _.wrap(
          ItemsSearcherView.prototype.getItemIds,
          function (fn) {
            if (!this.collection || !this.collection.models.length)
              return fn.apply(this, _.toArray(arguments).slice(1));
            _.each(this.collection.models, function (model) {
              var item_model = model.get("item");
              var imagesObject = sortImages(item_model);
              if (imagesObject)
                item_model.attributes.itemimages_detail = imagesObject;
            });
            return fn.apply(this, _.toArray(arguments).slice(1));
          }
        );

        HeaderMiniCartItemCellView.prototype.getContext = _.wrap(
          HeaderMiniCartItemCellView.prototype.getContext,
          function (fn) {
            if (!this.model || !this.model.attributes)
              fn.apply(this, _.toArray(arguments).slice(1));
            var item_model = this.model.get("item");
            if (!item_model || !item_model.attributes)
              fn.apply(this, _.toArray(arguments).slice(1));
            var imagesObject = sortImages(item_model);
            if (imagesObject)
              item_model.attributes.itemimages_detail = imagesObject;
            return fn.apply(this, _.toArray(arguments).slice(1));
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
  };
});
